import React, { useEffect, useState } from 'react';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if (e.key === 'Escape') {
        setActiveModal(null);
      }
    }
    if (activeModal) {
      document.body.style.overflow = 'hidden';
      window.addEventListener('keydown', handleKeyDown);
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [activeModal]);
  return <>
      <footer className="w-full bg-text py-10 px-6 md:px-8" style={{
      paddingTop: '20px',
      paddingBottom: '20px',
      paddingLeft: '30px',
      paddingRight: '30px'
    }} data-id="element-66">
        <div className="max-w-4xl mx-auto flex flex-col items-center gap-4" data-id="element-67">
          <div className="flex items-center gap-6" data-id="element-68">
            <button onClick={() => setActiveModal('privacy')} className="text-sm text-white/60 hover:text-white transition-colors duration-200 underline underline-offset-2" aria-label="Abrir Política de Privacidad" data-id="element-69">
              Política de Privacidad
            </button>
            <span className="text-white/30" aria-hidden="true" data-id="element-70">
              •
            </span>
            <button onClick={() => setActiveModal('terms')} className="text-sm text-white/60 hover:text-white transition-colors duration-200 underline underline-offset-2" aria-label="Abrir Términos y Condiciones" data-id="element-71">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-xs text-white/40" data-id="element-72">
            © {new Date().getFullYear()} Plan de Supervivencia Postparto. Todos
            los derechos reservados.
          </p>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-8" role="dialog" aria-modal="true" aria-label={activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'} data-id="element-73">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} aria-hidden="true" data-id="element-74" />

          {/* Modal Content */}
          <div className="relative w-full max-w-2xl max-h-[85vh] bg-white rounded-2xl shadow-2xl flex flex-col overflow-hidden z-10" data-id="element-75">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-lavender/20 bg-cream flex-shrink-0" data-id="element-76">
              <h2 className="text-xl font-bold text-text font-serif" data-id="element-77">
                {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h2>
              <button onClick={() => setActiveModal(null)} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-lavender-light/50 transition-colors text-text-light hover:text-text" aria-label="Cerrar" data-id="element-78">
                <XIcon className="w-5 h-5" data-id="element-79" />
              </button>
            </div>

            {/* Scrollable Body */}
            <div className="overflow-y-auto px-6 py-6 text-text/80 text-sm leading-relaxed space-y-5" data-id="element-80">
              {activeModal === 'privacy' ? <PrivacyContent data-id="element-81" /> : <TermsContent data-id="element-82" />}
            </div>

            {/* Footer */}
            <div className="px-6 py-4 border-t border-lavender/20 bg-cream flex-shrink-0" data-id="element-83">
              <button onClick={() => setActiveModal(null)} className="w-full py-2.5 bg-lavender-dark hover:bg-text text-white rounded-full text-sm font-semibold transition-colors duration-200" data-id="element-84">
                Cerrar
              </button>
            </div>
          </div>
        </div>}
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-xs text-text-light" data-id="element-85">
        Última actualización: febrero 2026
      </p>

      <div data-id="element-86">
        <h3 className="text-base font-bold text-text mb-2" data-id="element-87">
          1. Información que recopilamos
        </h3>
        <p data-id="element-88">
          Al adquirir el Plan de Supervivencia Postparto, recopilamos únicamente
          la información necesaria para procesar tu compra: nombre, dirección de
          correo electrónico y datos de pago. No almacenamos información de
          tarjetas de crédito directamente; esta es procesada de forma segura
          por nuestro proveedor de pagos.
        </p>
      </div>

      <div data-id="element-89">
        <h3 className="text-base font-bold text-text mb-2" data-id="element-90">
          2. Uso de la información
        </h3>
        <p data-id="element-91">Utilizamos tu información personal exclusivamente para:</p>
        <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-92">
          <li data-id="element-93">Procesar y entregar tu compra digital.</li>
          <li data-id="element-94">Enviarte el enlace de descarga del producto.</li>
          <li data-id="element-95">Comunicarnos contigo en caso de problemas con tu pedido.</li>
          <li data-id="element-96">
            Enviarte actualizaciones del producto, solo si has dado tu
            consentimiento.
          </li>
        </ul>
      </div>

      <div data-id="element-97">
        <h3 className="text-base font-bold text-text mb-2" data-id="element-98">
          3. Protección de datos
        </h3>
        <p data-id="element-99">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado,
          alteración, divulgación o destrucción. Tu información se almacena en
          servidores seguros y encriptados.
        </p>
      </div>

      <div data-id="element-100">
        <h3 className="text-base font-bold text-text mb-2" data-id="element-101">
          4. Compartir información
        </h3>
        <p data-id="element-102">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros, excepto a proveedores de servicios de confianza que nos
          asisten en la operación de nuestro sitio web y en el procesamiento de
          pagos, siempre que dichas partes acuerden mantener esta información
          confidencial.
        </p>
      </div>

      <div data-id="element-103">
        <h3 className="text-base font-bold text-text mb-2" data-id="element-104">5. Cookies</h3>
        <p data-id="element-105">
          Nuestro sitio puede utilizar cookies para mejorar la experiencia del
          usuario. Puedes configurar tu navegador para rechazar cookies, aunque
          esto podría afectar algunas funcionalidades del sitio.
        </p>
      </div>

      <div data-id="element-106">
        <h3 className="text-base font-bold text-text mb-2" data-id="element-107">6. Tus derechos</h3>
        <p data-id="element-108">Tienes derecho a:</p>
        <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-109">
          <li data-id="element-110">Acceder a los datos personales que tenemos sobre ti.</li>
          <li data-id="element-111">Solicitar la corrección de datos inexactos.</li>
          <li data-id="element-112">Solicitar la eliminación de tus datos personales.</li>
          <li data-id="element-113">
            Retirar tu consentimiento para comunicaciones en cualquier momento.
          </li>
        </ul>
      </div>

      <div data-id="element-114">
        <h3 className="text-base font-bold text-text mb-2" data-id="element-115">
          7. Cambios en esta política
        </h3>
        <p data-id="element-116">
          Nos reservamos el derecho de actualizar esta política de privacidad en
          cualquier momento. Los cambios serán publicados en esta página con la
          fecha de actualización correspondiente.
        </p>
      </div>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-xs text-text-light" data-id="element-117">
        Última actualización: febrero 2026
      </p>

      <div data-id="element-118">
        <h3 className="text-base font-bold text-text mb-2" data-id="element-119">
          1. Aceptación de los términos
        </h3>
        <p data-id="element-120">
          Al acceder y realizar una compra en este sitio web, aceptas cumplir
          con estos términos y condiciones de uso. Si no estás de acuerdo con
          alguna parte de estos términos, te pedimos que no realices la compra.
        </p>
      </div>

      <div data-id="element-121">
        <h3 className="text-base font-bold text-text mb-2" data-id="element-122">
          2. Producto digital
        </h3>
        <p data-id="element-123">
          El Plan de Supervivencia Postparto (0–30 días) es un producto digital
          en formato Ebook. Al completar tu compra, recibirás acceso inmediato
          para descargar el archivo. Este producto es para uso personal y no
          puede ser redistribuido, revendido ni compartido públicamente.
        </p>
      </div>

      <div data-id="element-124">
        <h3 className="text-base font-bold text-text mb-2" data-id="element-125">
          3. Descargo de responsabilidad médica
        </h3>
        <p data-id="element-126">
          Este producto es una guía práctica de organización para el período
          postparto.{' '}
          <strong data-id="element-127">
            No constituye consejo médico, psicológico ni profesional de salud.
          </strong>{' '}
          Si experimentas síntomas de depresión postparto, ansiedad severa u
          otras condiciones de salud, consulta inmediatamente con un profesional
          de salud calificado.
        </p>
      </div>

      <div data-id="element-128">
        <h3 className="text-base font-bold text-text mb-2" data-id="element-129">
          4. Política de reembolso
        </h3>
        <p data-id="element-130">
          Ofrecemos una garantía de satisfacción de 7 días. Si el producto no
          cumple con tus expectativas, puedes solicitar un reembolso completo
          dentro de los 7 días posteriores a la compra. Para solicitar un
          reembolso, comunícate con nosotros proporcionando tu comprobante de
          compra.
        </p>
      </div>

      <div data-id="element-131">
        <h3 className="text-base font-bold text-text mb-2" data-id="element-132">
          5. Propiedad intelectual
        </h3>
        <p data-id="element-133">
          Todo el contenido del Plan de Supervivencia Postparto, incluyendo
          textos, diseños, gráficos y estructura, está protegido por derechos de
          autor. Queda prohibida la reproducción, distribución o modificación
          del contenido sin autorización expresa por escrito.
        </p>
      </div>

      <div data-id="element-134">
        <h3 className="text-base font-bold text-text mb-2" data-id="element-135">
          6. Limitación de responsabilidad
        </h3>
        <p data-id="element-136">
          En ningún caso seremos responsables por daños directos, indirectos,
          incidentales o consecuentes que resulten del uso o la imposibilidad de
          uso de este producto. El producto se proporciona "tal cual" y "según
          disponibilidad".
        </p>
      </div>

      <div data-id="element-137">
        <h3 className="text-base font-bold text-text mb-2" data-id="element-138">
          7. Modificaciones
        </h3>
        <p data-id="element-139">
          Nos reservamos el derecho de modificar estos términos y condiciones en
          cualquier momento. Las modificaciones entrarán en vigor inmediatamente
          después de su publicación en el sitio web. El uso continuado del sitio
          después de dichos cambios constituye tu aceptación de los nuevos
          términos.
        </p>
      </div>

      <div data-id="element-140">
        <h3 className="text-base font-bold text-text mb-2" data-id="element-141">8. Ley aplicable</h3>
        <p data-id="element-142">
          Estos términos se regirán e interpretarán de acuerdo con las leyes
          aplicables, sin dar efecto a ningún principio de conflicto de leyes.
        </p>
      </div>
    </>;
}